import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'

const EditCoreCurriculumWebinar = props => {
  const { coreCurriculumWebinarId } = props.params

  return (
    <Edit
// @ts-ignore
      title='Edit Core Curriculum Webinar'
      fields={fields}
      apiPath={`admin/core_curriculum_webinars/${coreCurriculumWebinarId}`}
      successRedirectPath='/events/core-curriculum'
      buildMenuItems={menuItems}
    />
  )
}

export default EditCoreCurriculumWebinar
